/** Ibo brand logo — served from public/ so production builds stay self-contained. */

const PUBLIC_BASE = (process.env.PUBLIC_URL || '').replace(/\/$/, '');

/** Full-resolution brand mark (hero, navbar, footer). */
export const BRAND_LOGO = PUBLIC_BASE ? `${PUBLIC_BASE}/ibo-logo.png` : '/ibo-logo.png';

/**
 * Token-listing size (32×32 PNG) — public download URL for directories / BscScan.
 * File: frontend/public/ibo-logo-32.png
 */
export const BRAND_LOGO_32 = PUBLIC_BASE
  ? `${PUBLIC_BASE}/ibo-logo-32.png`
  : '/ibo-logo-32.png';

/** Hosts that no longer serve assets — fall back to BRAND_LOGO instead. */
const BLOCKED_LOGO_PATTERN = /emergentagent\.com|emergent\.sh/i;

/** Drop dead Emergent CDN URLs; otherwise return the candidate or fallback. */
export function resolveBrandLogoUrl(candidate, fallback = BRAND_LOGO) {
  const url = (candidate || '').trim();
  if (!url || BLOCKED_LOGO_PATTERN.test(url)) return fallback;
  return url;
}
